module.exports = __webpack_public_path__ + "static/media/icon-txt.58b0e70c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon-txt.svg
// module id = 1578
// module chunks = 0